/**
 * Get the correct path for static assets considering basePath
 */
export function getAssetPath(path: string): string {
  // Always add basePath for public assets since Next.js doesn't auto-prefix them
  const basePath = '/home';
  
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  
  return `${basePath}${normalizedPath}`;
}

/**
 * Get the correct URL for navigation considering basePath
 */
export function getNavPath(path: string): string {
  // For navigation, we always want relative paths as Next.js handles basePath
  return path.startsWith('/') ? path : `/${path}`;
}
